/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromValidate from 'Data/validate.js'
import AutopaySourceDetails from './AutopaySourceDetails/index'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneHeader from 'DesignSystem/TysiaSelectOne/TysiaSelectOneHeader/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsEditAutopay/Content/ChooseAutopaySource/Content",
  onChange,
  isInvalid,
  isSubmitting
  
}) {
let editAutopayInfoAutopaySourcesValueData = fromData.useDataValue({ viewPath,
context: 'edit_autopay_info',
path: 'autopay_sources',
})
let paymentsEditAutopayAutopaySourceIdValueData = fromData.useDataValue({ viewPath,
context: 'payments_edit_autopay',
path: 'autopay_source_id',
})
let paymentsEditAutopayAutopaySourceIdIsValidData = fromData.useDataIsValid({ viewPath,
context: 'payments_edit_autopay',
path: 'autopay_source_id',
validate: fromValidate.textInput,
required: true,
})
let paymentsEditAutopayAutopaySourceIdChangeData = fromData.useDataChange({ viewPath,
context: 'payments_edit_autopay',
path: 'autopay_source_id',
})
let paymentsEditAutopayIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'payments_edit_autopay',
})
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 marginTop={0}
 isMultiChoice={false}
 data="edit_autopay_info.autopay_sources"
 from={editAutopayInfoAutopaySourcesValueData}
 data="payments_edit_autopay.autopay_source_id"
 validate="/Data/validate.js textInput"
 required={true}
 value={paymentsEditAutopayAutopaySourceIdValueData}
 onChange={paymentsEditAutopayAutopaySourceIdChangeData}
 invalid={!paymentsEditAutopayAutopaySourceIdIsValidData}
 data="payments_edit_autopay"
 disabled={paymentsEditAutopayIsSubmittingData}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneHeader
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneHeader`}
>
{childProps => (
<TysiaSelectOneLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 text="Autopay source"
 weight="medium"
/>
)}
</TysiaSelectOneHeader>
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
 backgroundColor="white"
 borderColor={dtColorsNeutral300}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
</React.Fragment>
)}
</TysiaSelectOne>
<AutopaySourceDetails
  viewPath={`${viewPath}/AutopaySourceDetails`}
/>
</div>
{children}
</React.Fragment>)
}